// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Stats_statsSection__RX4v1 {\n\n}\n\n.Stats_statsSection__RX4v1 h2, .Stats_statsSection__RX4v1 h3, .Stats_statsSection__RX4v1 p {\n    margin: 0;\n}", "",{"version":3,"sources":["webpack://./src/assets/style/Stats.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,SAAS;AACb","sourcesContent":[".statsSection {\n\n}\n\n.statsSection h2, .statsSection h3, .statsSection p {\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statsSection": "Stats_statsSection__RX4v1"
};
export default ___CSS_LOADER_EXPORT___;
